<template>
  <a-layout-content class="hrm-content">
    <div class="content">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </div>
  </a-layout-content>
</template>

<script>
  export default {
    name: 'EhfContent',
  }
</script>

<style lang="scss" scoped>
  .hrm-content {
    height: 100vh !important;
    overflow: auto;
    &[data-full-path^='/hrm/examine_improve'] {
      .content {
        margin: 0;
        border-left: 1px solid #ebebeb;
      }
    }
    .content {
      min-height: calc(100vh - #{$ehf-margin} - #{$ehf-margin});
      padding: 0;
      margin: $ehf-margin;
      /*background: #fff;*/
    }
    .error-container {
      height: 100vh !important;
    }
  }
</style>
